const TabTitle = (newTitle) => {
  return (document.title = newTitle);
};

export default TabTitle;
